import {
    // FilledNewsIcon,
    FilledTrophyIcon,
    FilledWalletIcon,
    HeadOfficeIcon,
    AboutIcon,
    // PharmacyIcon,
    FaqsIcon, AdminIcon,
} from "@/components/icons"
import type {Group, HubRole, Store} from "@/data"

export interface MenuItemType {
  label: string
  path?: string
  icon?: any
  role?: HubRole | IRoleFn;
  children?: MenuItemType[]
  depth?: number
}

export interface StoreSelectionItemType {
  label: string
  icon?: any
  children?: Group[] | Store[]
  placeholder?: string
}

export interface IRoleFn {
    (roles: HubRole[]): boolean
}

const axeOnlyRoleFn = (roles: HubRole[]) => {
    return (roles.includes("axe") && !roles.includes("arrotex") && !roles.includes("vidacorp"));
}

const notAxeOnlyRoleFn = (roles: HubRole[]) => {
    return !axeOnlyRoleFn(roles);
}

export const sidebarMenu: MenuItemType[] = [
  {
    label: 'About',
    path: '/about',
    icon: AboutIcon,
    depth: 0,
  },
  {
    label: 'DBG Benefits',
    path: '/benefits',
    icon: FilledWalletIcon,
    depth: 0,
    role: notAxeOnlyRoleFn,
    children: [
      { label: 'Arrotex Value', path: '/benefits/arrotex'},
      { label: 'Vidacorp Value', path: '/benefits/vidacorp'},
      { label: 'Axe Value', path: '/benefits/axe'}
    ]
  },
  {
    label: 'Axe Value',
    path: '/benefits/axe',
    icon: FilledWalletIcon,
    depth: 0,
    role: axeOnlyRoleFn,
    children: []
  },
  {
    label: 'Your Offers',
    path: '/offers/arrotex',
    icon: FilledTrophyIcon,
    role: "administrator",
    depth: 0,
    children: [
      { label: 'Arrotex', path: '/offers/arrotex', role: "administrator"  },
      { label: 'Vidacorp', path: '/offers/vidacorp', role: "administrator"  }
    ]
  },
  {
    label: 'FAQs',
    path: '/faqs',
    icon: FaqsIcon,
    depth: 0,
  },
  {
    label: 'Admin',
    path: '/admin/permissions',
    icon: AdminIcon,
    role: "administrator",
    depth: 0,
    children: [
        { label: 'User Permissions', path: '/admin/permissions', role: "administrator" },
        { label: 'Assignments', path: '/admin/assignments', role: "administrator" },
        { label: 'Datasets', path: '/admin/datasets', role: "administrator" },
    ]
  },
  // {
  //   label: 'DBG News',
  //   path: '/home/news',
  //   icon: FilledNewsIcon,
  //   depth: 0,
  //   children: [
  //     { label: '60 Day Dispensing', path: '/home/news/60DD' },
  //     { label: 'Discontinued Products', path: '/home/news/discontinued' }
  //   ]
  // }
  // Add more items as needed
]

export const storeSelection: StoreSelectionItemType[] = [
  {
    label: 'Head Office',
    icon: HeadOfficeIcon,
    placeholder: 'Head office name'
  },
  // {
  //   label: 'Pharmacy',
  //   icon: PharmacyIcon,
  //   placeholder: 'Pharmacy name'
  // }
]
